<template>
  <article>
    <div
      ref="chart"
      :style="this.graphStyle"
    />
  </article>
</template>

<script>
import Dygraph from 'dygraphs'

export default {
  props: {
    isDisplaySeries: {
      type: Array,
      default: null
    },
    graphData: {
      type: Array,
      default: null
    },
    graphOptions: {
      type: Object,
      default: null
    },
    graphStyle: {
      type: Object,
      default: null
    },
    reRenderValue: {
      type: Number,
      default: 0
    }
  },
  components: {
  },
  watch: {
    graphData () {
      this.renderChart(this.graphData, this.graphOptions)
    },
    isDisplaySeries () {
      this.updateVisibility()
    },
    reRenderValue () {
      this.renderChart(this.graphData, this.graphOptions)
    }
  },
  mounted () {

  },
  methods: {
    renderChart (graphData, graphOptions) {
      graphOptions['colors'] = this.colors
      this.g = new Dygraph(this.$refs.chart, graphData, graphOptions)
      // this.updateVisibility()
    },
    updateVisibility () {
      this.g.updateOptions({
        'visibility': this.isDisplaySeries
      })
    }
  },
  data () {
    return {
      g: '',
      colors: ['#e34160', '#20d0bf', '#2f8dfa', '#f8c753', '#ec7e30', '#1aa879', '#1553b6', '#bd41e3', '#cc917c', '#516d88']
    }
  }
}
</script>

<style scope="scss">
  article {
    max-width: 100%;
    height: 100%;
  }
  .dygraph-title {
    font-size: 3rem;
    text-shadow:gray 2px 2px 2px;
    text-align: center;
  }
</style>
